import * as React from 'react'
import { TextureProps } from './index'

export default class Dirty01 extends React.Component<TextureProps> {
  static optionValue = 'Dirty01'

  render () {
    const pieceId = 'Texture/Dirty01'

    return (
      <g id={pieceId}
         mask={`url(#${this.props.maskID})`}
         stroke='none'
         strokeWidth='1'
         fill='none'
         fillRule='evenodd'>
        <path
          d='M-9.11955629,122.092261 C-4.75864768,91.4015967 3.93799819,117.533631 24.8655794,112.12396 C34.1114596,109.733948 26.640969,99.2957595 33.5369251,94.7717324 C39.3618156,90.9503678 47.2997509,94.0293736 53.9721466,91.5579533 C63.6014225,87.99132 63.4748482,80.7354599 72.4469492,79.6510309 C80.9317383,78.6255016 89.8203396,82.0049911 98.377883,80.7354599 C114.52834,78.3395026 107.906382,46.7111063 120.01742,41.1251889 C132.128458,35.5392715 152.06764,45.1858521 154.677658,61 C156.373936,71.2777829 151.55461,95.5377314 140.21968,133.779846 L-9.11955629,133.779846'
          id='clean-me'
          fillOpacity='0.2'
          fill='#000000'/>
        <path
          d='M35.9268464,122 C73.6043905,122 77.5268977,107.25032 96.0650387,100.492846 C114.60318,93.7353716 130.845661,111.213512 137.077849,94.2331339 C141.232642,82.9128816 143.298631,94.895504 143.275816,130.181001 L35.9268464,130.181001 L35.9268464,122 Z'
          id='clean-me'
          fillOpacity='0.1'
          fill='#000000'/>
        <path
          d='M-2,4.86732511 C9.73320733,3.74652018 5.96193192,16.806064 10.5973598,16.806064 C12.4464321,16.806064 14.6252877,8.34889769 17.983215,8.34889769 C20.4379638,8.34889769 19.9753096,13.8424996 25.3050084,13.2617118 C30.3076746,12.7165614 29.3753984,9.26870987 31.9026708,9.26870987 C37.3453964,9.26870987 35.2872819,29.4636252 39.6440681,29.4636252 C44.0008542,29.4636252 45.3737266,14.6679622 47.2914382,8.8163548 C49.7180554,1.41189864 64.2635329,-2.73836446 53.8922857,-5.67986809 L-2.28674568,-5.67986809'
          id='clean-me'
          fillOpacity='0.4'
          fill='#000000'/>
      </g>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/bot/texture/Dirty01.tsx